import React from "react";

const ConfirmationModal = (props) => {
  return (
    <>
      <button
        type="button"
        className={props?.btnClass}
        id={`${props?.target}-btn-trigger`}
        data-bs-toggle="modal"
        data-bs-target={`#${props?.target}`}
        disabled={props.disabled}
      >
        {props?.button}
      </button>

      <div
        className="modal fade"
        id={props?.target}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                {props?.title}
              </h1>
              <button
                type="button"
                id={`${props?.target}-close`}
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">{props?.body}</div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-danger px-4 py-1"
                data-bs-dismiss="modal"
              >
                {props?.close}
              </button>
              <button
                type="button"
                className="btn btn-primary px-4 py-1"
                onClick={props?.onClick}
              >
                {props?.save}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;
